import { IRutinInfo } from '../../../../../Types/RutinInfoType';

const BJStyrvardeMeny: IRutinInfo[] = [];

export default BJStyrvardeMeny;
